import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsLoaderService {
    pathEnv:string
    googleApiKey:string

    private scriptLoaded = false;
    constructor(
        private http:HttpClient
    ) {}

    getApiKey() {
        // this.pathEnv = "https://b2ctest.ecredit.it/appBD/environment.json"
        this.pathEnv = "https://atm.staging.findomestic.it/assets/configMap/env.json"
        this.http.get(this.pathEnv).subscribe((data: any) => {
            this.googleApiKey = data.apiKey;
        })
    }

    loadGoogleMapsApi(): Promise<void> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
            if (this.scriptLoaded) {
                resolve();
                return;
            }


            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleApiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.scriptLoaded = true;
                resolve();
            };
            script.onerror = (error) => reject(error);
            document.body.appendChild(script);
        },3000);

        });
    }
}
